'use client'

import { useEffect, useState } from 'react'
import { BRAND } from './MarketingChrome'

export function EdEyebrow({ children, color = BRAND.coral }: { children: React.ReactNode; color?: string }) {
  return <div className="ed-eyebrow" style={{ color }}>{children}</div>
}

export function PullItalic({ children, color = BRAND.coral, ...rest }: { children: React.ReactNode; color?: string } & React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className="pull-italic" style={{ color, ...rest.style }} {...rest}>
      {children}
    </span>
  )
}

export function Cropped({ children, style, className }: { children: React.ReactNode; style?: React.CSSProperties; className?: string }) {
  return (
    <div className={`cropped ${className ?? ''}`} style={{ padding: 10, ...style }}>
      <span className="cm cm-tl" />
      <span className="cm cm-tr" />
      <span className="cm cm-bl" />
      <span className="cm cm-br" />
      {children}
    </div>
  )
}

export function EditorialRule() {
  return <hr style={{ border: 'none', borderTop: `1px solid ${BRAND.rule}`, margin: 0 }} />
}

export function SectionMarker({ n, label }: { n: string; label: string }) {
  return (
    <div className="flex items-baseline gap-4 font-mono-ed" style={{ fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', color: BRAND.muted }}>
      <span style={{ color: BRAND.coral, fontWeight: 700 }}>§ {n}</span>
      <span>— {label}</span>
    </div>
  )
}

// Scroll-spy: tracks which section id is currently in view
export function useActiveHeading(ids: string[]): string | null {
  const [active, setActive] = useState<string | null>(ids[0] ?? null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Pick the first entry that is intersecting near the top of the viewport
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)
        if (visible[0]) {
          setActive(visible[0].target.id)
        }
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    )

    ids.forEach((id) => {
      const el = document.getElementById(id)
      if (el) observer.observe(el)
    })

    return () => observer.disconnect()
  }, [ids])

  return active
}
